export enum SaleItemType {
  KIT = 'KIT',
  PRODUCT_COLOR = 'PRODUCT_COLOR',
  ELASTIC_PRODUCT_COLOR = 'ELASTIC_PRODUCT_COLOR',
}

export interface GetKitActionDTO {
  type: SaleItemType.KIT;
  isShopping: boolean;
  kitId: string;
}

export interface GetProductColorActionDTO {
  type: SaleItemType.PRODUCT_COLOR;
  isShopping: boolean;
  productColorId: string;
}

export type GetProductActionDTO = GetKitActionDTO | GetProductColorActionDTO;
